<template>
  <div>
    <div class="section-heading">
      <h4>Add Product</h4>
      <!-- <p>Add your product details</p> -->
      <p class="w-70 mt-3">
        Optimize your strategy by tracking the products that matter most to your
        brand. <br />
        Choose the key SKUs you want to monitor across platforms and let Weavr
        provide insights on their performance.
      </p>
    </div>
    <div class="mt-4">
      <p class="font-weight-bold">Platforms Selected</p>
      <div class="d-flex w-50 flex-wrap" v-if="selectedPlatforms.length">
        <button
          class="demo-btn active"
          v-for="platform of selectedPlatforms"
          :key="platform.platform_id"
        >
          {{ platform.platform_name }}
        </button>
      </div>
      <p v-else style="color: var(--red); font-size: 12px; font-weight: 400">
        Please select platform(s) to continue
      </p>
    </div>
    <!-- Table for uploading products -->
    <div
      v-if="selectedPlatforms.length"
      class="section-heading mt-4"
      style="max-width: 920px"
    >
      <div class="d-flex align-items-center justify-content-between">
        <p class="mr-4">Download template and upload as per platform.</p>
        <div class="tw-flex tw-gap-4 tw-items-center">
          <button
            class="primarycolor"
            title="Download Template"
            @click="downloadProductTemplate"
          >
            Download
          </button>
          <button class="primarycolor">
            <input
              type="file"
              class="d-none "
              accept=".xlsx"
              id="uploadfile"
              @change="uploadProductTemplate($event)"
            />
            <label for="uploadfile">
              <div
                class="tw-py-[6px]"
                style="border-radius: 5px !important; cursor: pointer"
              >
                Upload
              </div>
            </label>
            <div
              v-if="!Object.keys(uploadedProducts).length && invalidCheck"
              style="color: var(--red); font-size: 13px"
            >
              Please upload the products.
            </div>
            <div
              v-else-if="Object.keys(uploadedProducts).length"
              style="color: green; font-size: 13px"
            >
              {{ uploadedProducts.file.name }}
            </div>
          </button>
        </div>
      </div>

      <!-- <table class="demo-table">
        <thead>
          <tr>
            <th>Platforms</th>
            <th>Download Template</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row of selectedPlatforms" :key="row.platform_id">
            <td class="text-left pl-4">
              <div class="tw-flex tw-items-center tw-justify-center tw-gap-2">
                <img
                  :src="getImageUrl(row.slug)"
                  width="20"
                  :alt="row.platform_name + ' logo'"
                />
                <span style="font-size: 14px">{{ row.platform_name }}</span>
              </div>
            </td>
            <td class="py-3">
              <button
                class="download-btn"
                title="Download Template"
                @click="downloadProductTemplate"
              >
                <div class="tw-flex tw-items-center tw-justify-center tw-gap-1">
                  <img
                    src="../../../../../public/Icons_SVG/DownloadArrow.svg"
                    width="18"
                    alt="download-template"
                  />
                </div>
              </button>
            </td>
          </tr>
        </tbody>
      </table> -->
    </div>
    <div class="mt-4">
      <div class="d-flex">
        <button class="primarycolor mr-3" @click="saveUploadedProducts">
          Save and Next
        </button>
        <button
          class="navigationButton"
          @click="setSelectedSection(previousSection)"
        >
          Back
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "Products",
  data() {
    return {
      uploadedProducts: {},
      invalidCheck: false,
      currentSectionIndex: null,
      nextSection: null,
      previousSection: null,
    };
  },
  computed: {
    ...mapState("DemoStore", [
      "selectedFeatures",
      "selectedPlatforms",
      "sections",
      "selectedSection",
    ]),
  },
  mounted() {
    if (!this.selectedPlatforms.length) {
      this.getFeatureWisePlatform();
    }
    this.currentSectionIndex = this.sections.indexOf(this.selectedSection);
    this.nextSection = this.sections[this.currentSectionIndex + 1];
    this.previousSection = this.sections[this.currentSectionIndex - 1];
  },
  methods: {
    ...mapActions("DemoStore", [
      "setDemoLoader",
      "setSelectedSection",
      "setTotalPlatforms",
      "setSelectedPlatforms",
    ]),
    getFeatureWisePlatform() {
      this.setDemoLoader(true);
      const url = "/api/demo/feature_platform";
      const payload = {
        feature_ids: this.selectedFeatures.map((feature) => feature.feature_id),
        region_id: this.$store.state.DemoStore.selectedRegion.id,
      };

      this.$http
        .post(url, payload)
        .then((res) => {
          let resData = res.body.data;
          let filteredSelectedPlatforms = [];

          if (resData.length)
            filteredSelectedPlatforms = resData.filter(
              (platform) => platform.isSelected && platform
            );

          this.setTotalPlatforms(resData);
          this.setSelectedPlatforms(filteredSelectedPlatforms);
          this.setDemoLoader(false);
        })
        .catch((err) => {
          console.log("Erron in getting platforms", err);
          this.setDemoLoader(false);
        });
    },
    downloadProductTemplate() {
      // window.location = "/static/demo/product_details.xlsx"
      const url = "/api/v3/excel";
      this.$http
        .get(url)
        .then((res) => {
          window.location = res.data.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    uploadProductTemplate(e) {
      this.uploadedProducts = {
        ...this.uploadedProducts,
        file: e.target.files[0],
      };
    },

    getImageUrl(slug) {
      try {
        return require(`../../../../../public/platform_svg/${slug}.svg`);
      } catch (e) {
        return require("../../../../../public/img/default_platform.png");
      }
    },
    saveUploadedProducts() {
      const url = "/api/demo/products";

      if (!Object.keys(this.uploadedProducts).length) {
        this.invalidCheck = true;
        this.$bvToast.toast(`Please upload products for all the platforms.`, {
          title: "Weavr Sense",
          variant: "danger",
          toaster: "b-toaster-bottom-center",
          autoHideDelay: 3000,
        });
        return;
      }

      this.setDemoLoader(true);

      const payload = new FormData();
      // Object.keys(this.uploadedProducts).forEach((fileName) => {
      payload.append("file", this.uploadedProducts.file);
      // });
      payload.append(
        "region_id",
        this.$store.state.DemoStore.selectedRegion.id
      );

      this.$http
        .post(url, payload)
        .then((res) => {
          this.setDemoLoader(false);
          this.$bvToast.toast(`Product(s) uploaded successfully.`, {
            title: "Weavr Sense",
            variant: "success",
            toaster: "b-toaster-bottom-center",
            autoHideDelay: 3000,
          });
          this.uploadedProducts = {};
          this.setSelectedSection(this.nextSection);
        })
        .catch((err) => {
          this.setDemoLoader(false);
          this.$bvToast.toast(`Error in uploading product(s).`, {
            title: "Weavr Sense",
            variant: "danger",
            toaster: "b-toaster-bottom-center",
            autoHideDelay: 3000,
          });
        });
    },
  },
};
</script>

<style scoped>
.demo-input {
  padding: 4px 10px;
  border: 1px solid #ebebeb;
  border-radius: 5px;
  color: var(--primary_brand);
}

.demo-input::placeholder {
  color: #919191;
  font-family: "Poppins", sans-serif;
}

.demo-input:focus {
  outline: none !important;
  box-shadow: none !important;
  border-color: var(--primary_brand) !important;
}

.demo-btn {
  color: #919191;
  background-color: transparent;
  border: 1px solid #ebebeb;
  border-radius: 5px;
  padding: 6px 12px;
  margin-right: 20px;
  margin-bottom: 12px;
}

.demo-btn.active {
  background-color: var(--primary_brand);
  border: 1px solid var(--primary_brand);
  color: white;
  font-weight: 500;
}

.demo-btn:focus {
  outline: none !important;
  box-shadow: none !important;
  border-color: #ebebeb !important;
}

.demo-btn.active:focus {
  outline: none !important;
  box-shadow: none !important;
  border-color: var(--primary_brand) !important;
}

.section-heading h4 {
  font-size: 18px;
  font-weight: 600;
}

.section-heading p {
  color: #5e5e5e;
  font-size: 14px;
  font-weight: 500;
}
.download-btn {
  background: transparent;
  border: 1px solid #065559;
  border-radius: 3px;
  width: 34px;
  height: 34px;
}
.navigationButton {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 16px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins", sans-serif;
}

.navigationButton:hover {
  background: var(--accent_color-80);
}

.navigationButton:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

button.primarycolor {
  height: 35px;
  border: none !important;
  margin: 0;
  background: var(--primary_brand);
  color: white;
  border-radius: 5px;
  font-size: 16px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}

button.primarycolor:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}
</style>
<style lang="scss">
table.demo-table {
  border-radius: 5px;
  border-spacing: 0;
  border-collapse: separate;
  border: 1px solid #d5d5d5 !important;
  overflow: hidden;
  min-width: 900px !important;

  > thead > tr > th {
    background-color: #e7eeef !important;
    padding: 16px 32px !important;
    font-family: "Poppins", sans-serif !important;
    font-size: 14px !important;
    font-weight: 600 !important;
    color: #050a13 !important;
  }

  > tbody > tr > td {
    font-family: "Poppins", sans-serif !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    color: black !important;
  }

  // >tbody>tr>td:first-child {
  //     text-align: ;
  // }

  /* Apply a border to the right of all but the last column */
  th:not(:last-child),
  td:not(:last-child) {
    border-right: 1px solid #d5d5d5 !important;
  }

  /* Apply a border to the bottom of all but the last row */
  > thead > tr:not(:last-child) > th,
  > thead > tr:not(:last-child) > td,
  > tbody > tr:not(:last-child) > th,
  > tbody > tr:not(:last-child) > td,
  > tfoot > tr:not(:last-child) > th,
  > tfoot > tr:not(:last-child) > td,
  > tr:not(:last-child) > td,
  > tr:not(:last-child) > th,
  > thead:not(:last-child),
  > tbody:not(:last-child),
  > tfoot:not(:last-child) {
    border-bottom: 1px solid #d5d5d5 !important;
  }

  > tbody:last-child > tr > td:first-child > div:last-child {
    border-bottom: none !important;
  }
}
</style>
